export default __webpack_public_path__ + "static/media/groupBg.d27ca30c.png";